import { alpha } from '@mui/material';
import { softColors } from './commonTableStyles.js';

export const accountantsManagerStyles = {
  container: {
    width: '100%'
  },

  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mb: 2.5,
    pb: 1.5,
    borderBottom: `1px solid ${alpha(softColors.border, 0.2)}`
  },

  headerTitle: {
    fontWeight: 600,
    fontSize: '1rem',
    color: 'text.primary'
  },

  addButton: {
    fontSize: '13px',
    textTransform: 'none',
    color: softColors.primary,
    fontWeight: 600,
    borderRadius: 1.5,
    px: 2,
    py: 0.6,
    border: `1px solid ${alpha(softColors.primary, 0.2)}`,
    backgroundColor: 'transparent',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: alpha(softColors.primary, 0.05),
      borderColor: softColors.primary
    }
  },

  listContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2.5
  },

  card: (isPrimary) => ({
    border: `1px solid ${isPrimary ? softColors.primary : alpha(softColors.border, 0.3)}`,
    borderRadius: 2,
    padding: 2.5,
    background: isPrimary ? alpha(softColors.primary, 0.04) : 'white',
    position: 'relative',
    transition: 'all 0.2s ease',
    '&:hover': {
      boxShadow: `0 2px 8px ${alpha(softColors.primary, isPrimary ? 0.12 : 0.06)}`
    }
  }),


  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mb: 2.5
  },

  cardHeaderLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 1
  },

  starBadge: {
    width: 20,
    height: 20,
    borderRadius: '50%',
    backgroundColor: alpha(softColors.primary, 0.12),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  cardTitle: (isPrimary) => ({
    fontWeight: 600,
    fontSize: '0.9rem',
    color: isPrimary ? softColors.primary : 'text.secondary'
  }),

  cardHeaderRight: {
    display: 'flex',
    gap: 0.5
  },

  starButton: (isPrimary) => ({
    color: isPrimary ? softColors.primary : 'grey.400',
    transition: 'all 0.2s ease',
    '&:hover': !isPrimary ? {
      color: softColors.primary,
      backgroundColor: alpha(softColors.primary, 0.08)
    } : {}
  }),

  deleteButton: {
    color: 'error.main',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: alpha('#f44336', 0.08)
    }
  },


  divider: {
    mb: 2,
    borderColor: alpha(softColors.border, 0.15)
  },

  fieldsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2
  },

  fieldWrapper: {

  },


  label: {
    fontSize: '13px',
    fontWeight: 600,
    color: 'text.secondary',
    display: 'block',
    mb: 1
  },

  inputBase: {
    width: '100%',
    padding: '11px 12px',
    border: `1px solid ${alpha(softColors.border, 0.3)}`,
    borderRadius: '8px',
    fontSize: '14px',
    fontFamily: 'inherit',
    direction: 'rtl',
    backgroundColor: '#ffffff',
    transition: 'all 0.2s ease',
    outline: 'none'
  },

  loadingText: {
    mt: 1,
    display: 'block',
    color: softColors.info,
    fontWeight: 500,
    fontSize: '12px'
  },

  checkboxContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    p: 1.2,
    borderRadius: 1.5,
    backgroundColor: alpha(softColors.background, 0.3),
    border: `1px solid ${alpha(softColors.border, 0.15)}`
  },

  checkboxStyle: {
    cursor: 'pointer',
    width: '18px',
    height: '18px',
    accentColor: softColors.primary
  },

  checkboxLabel: {
    fontSize: '14px',
    cursor: 'pointer',
    fontWeight: 500,
    color: '#444'
  }
};

export const inputFocusStyle = {
  borderColor: softColors.primary,
  boxShadow: `0 0 0 3px ${alpha(softColors.primary, 0.1)}`
};

export const inputBlurStyle = {
  borderColor: alpha(softColors.border, 0.4),
  boxShadow: 'none'
};